<template>
    <div id="acarsIndex">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initAcarsIndex} from 'utils/initPageData'

export default { 
    name: 'AcarsIndex',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],
            index: [],
            page1: [
                [
                    ['ACARS',['','','']],
                    [1,1]
                ], 
                [
                    [ '', '' ], 
                    [ '', '' ] 
                ], 
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '\xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 敬请期待', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
            ]
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initAcarsIndex(this)
    }
}
</script>

<style scoped>

</style>